import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginScreen from './screens/LoginScreen';
import RegisterScreen from './screens/RegisterScreen';
import ResetPasswordScreen from './screens/ResetPasswordScreen';
import ResetPasswordConfirmScreen from './screens/ResetPasswordConfirmScreen';
import DashboardScreen from './screens/DashboardScreen';
import ProfileScreen from './screens/profileScreen';
import LandingPage from './screens/LandingPage';
import BusinessScreen from './screens/BusinessPageScreen';
import BusinessVerificationPage from './screens/BusinessVerificationPage';
import BusinessSettingsPage from './screens/BusinessSettingsPage';
import BusinessProfilePage from './screens/BusinessProfilePage';
import BusinessCreditPercentagePage from './screens/BusinessCreditPercentagePage';
import BusinessStaffPage from './screens/BusinessStaffPage';
import StaffLookUpPage from './screens/StaffLookUpPage';
import AddExistingStaffPage from './screens/AddExistingStaffPage';
import AddNewStaffPage from './screens/AddNewStaffPage';
import EditStaffPage from './screens/EditStaffPage';
import PrivateRoute from './components/PrivateRoute';
import AddBusinessPage from './screens/AddBusinessPage';
import VerifyEmailScreen from './screens/VerifyEmailScreen';
import VerifyPhoneByLink from './screens/VerifyPhoneByLink';
import UploadProfilePictureScreen from './screens/UploadProfilePictureScreen';
import ChangePasswordScreen from './screens/ChangePasswordScreen';
import PrivacyPolicyPage from './screens/PrivacyPolicyPage';
import ContactUsPage from './screens/ContactUsPage';
import ContactSuccessPage from './screens/ContactSuccessPage';
import DeleteAccountPage from './screens/DeleteAccountPage';
import AdminDashboard from './screens/AdminDashboard';
import AdminUsersPage from './screens/AdminUsersPage';
import AdminBusinessesPage from './screens/AdminBusinessesPage';
import EditUserPage from './screens/EditUserPage';
import DeletedUsersPage from './screens/DeletedUsersPage';
import GiftCardPage from './screens/GiftCardPage';
import ImpersonationBanner from './components/ImpersonationBanner';


const App: React.FC = () => {
  return (
    <Router>
      <ImpersonationBanner />
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginScreen />} />
        <Route path="/register" element={<RegisterScreen />} />
        <Route path="/reset-password" element={<ResetPasswordScreen />} />
        <Route path="/reset-password/confirm" element={<ResetPasswordConfirmScreen />} />
        <Route path="/verify-email" element={<VerifyEmailScreen />} />
        <Route path="/verify-phone" element={<VerifyPhoneByLink />} />
        <Route path="/upload-profile-picture" element={<UploadProfilePictureScreen />} />
        <Route path="/change-password" element={<ChangePasswordScreen />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/contact" element={<ContactUsPage />} />
        <Route path="/contact-us" element={<ContactUsPage />} />
        <Route path="/contact-success" element={<ContactSuccessPage />} />
        <Route path="/code/:code" element={<GiftCardPage />} />

        {/* Protected routes */}
        <Route 
          path="/dashboard" 
          element={
            <PrivateRoute>
              <DashboardScreen />
            </PrivateRoute>
          } 
        />

        <Route 
          path="/profile" 
          element={
            <PrivateRoute>
              <ProfileScreen />
            </PrivateRoute>
          }
        />

        <Route 
          path="/delete-account" 
          element={
            <PrivateRoute>
              <DeleteAccountPage />
            </PrivateRoute>
          }
        />

        <Route
          path='/businesses'
          element={
            <PrivateRoute>
              <BusinessScreen />
            </PrivateRoute>
          }
        />

        <Route
          path='/business/:businessId/settings'
          element={
            <PrivateRoute>
              <BusinessSettingsPage />
            </PrivateRoute>
          }
        />

        <Route
          path='/business/:businessId/verify'
          element={
            <PrivateRoute>
              <BusinessVerificationPage />
            </PrivateRoute>
          }
        />

        <Route
          path='/business/:businessId/profile'
          element={
            <PrivateRoute>
              <BusinessProfilePage/>
            </PrivateRoute>
          }
        />

        <Route
          path='/business/:businessId/credit-percentages'
          element={
            <PrivateRoute>
              <BusinessCreditPercentagePage />
            </PrivateRoute>
          }
        />

        <Route
          path='/business/:businessId/staff'
          element={
            <PrivateRoute>
              <BusinessStaffPage/>
            </PrivateRoute>
          }
        />

        <Route
          path='/business/:businessId/staff/add'
          element={
            <PrivateRoute>
              <StaffLookUpPage/>
            </PrivateRoute>
          }
        />

        <Route
          path='/business/:businessId/staff/add-existing'
          element={
            <PrivateRoute>
              <AddExistingStaffPage/>
            </PrivateRoute>
          }
        />
        <Route
          path='/business/:businessId/staff/add-new'
          element={
            <PrivateRoute>
              <AddNewStaffPage/>
            </PrivateRoute>
          }
        />

        <Route
          path='/business/:businessId/staff/:staffId/edit'
          element={
            <PrivateRoute>
              <EditStaffPage/>
            </PrivateRoute>
          }
        />
        <Route
          path='/businesses/new'
          element={
            <PrivateRoute>
              <AddBusinessPage />
            </PrivateRoute>
          }
        />

        {/* Admin routes */}
        <Route
          path='/admin'
          element={
            <PrivateRoute>
              <AdminDashboard />
            </PrivateRoute>
          }
        />

        <Route
          path='/admin/users'
          element={
            <PrivateRoute>
              <AdminUsersPage />
            </PrivateRoute>
          }
        />

        <Route
          path='/admin/users/:userId/edit'
          element={
            <PrivateRoute>
              <EditUserPage />
            </PrivateRoute>
          }
        />

        <Route
          path='/admin/users/deleted'
          element={
            <PrivateRoute>
              <DeletedUsersPage />
            </PrivateRoute>
          }
        />

        <Route
          path='/admin/businesses'
          element={
            <PrivateRoute>
              <AdminBusinessesPage />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;